/**
 * Announcements Configuration
 * 
 * To add a new announcement:
 * 1. Add a new object to the top of the ANNOUNCEMENTS array.
 * 2. Set a unique ID (increment from the previous one).
 * 3. Set 'active' to true.
 * 4. The app will automatically show it to users who haven't seen this specific ID yet.
 */

export const ANNOUNCEMENTS = [
  {
    id: 1,
    title: "Takeaway Option Available!",
    version: "1.1.0",
    content: "You can now place an order and pick it up directly from our location. There's no delivery charge for takeaway orders—simple and free! 😊",
    active: true,
    createdAt: "2026-01-09"
  }
];

export const getLatestActiveAnnouncement = () => {
  return ANNOUNCEMENTS.find(a => a.active);
};
